import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { DropDownList } from "../../models/dropdownlist.model";
import { PrincipalCheckedModel } from "../../models/Principal/principal-checked.model";
import { MenuCheckedModel } from "../../models/Principal/menu-checked.model";
import { MenuCheckedTreeViewModel } from "../../models/Principal/menu-checked-treeview.model";
import { TreeViewComponent, TreeView } from '@syncfusion/ej2-angular-navigations';
import { enableRipple, getComponent } from '@syncfusion/ej2-base';
enableRipple(true);

@Component({
    selector: '',
    templateUrl: 'user-role-on-menu.html',
})
export class UserRoleOnMenuComponent implements OnInit {

    userSelected: number = 0;
    userType: string = "";
    fields: Object = { text: 'label', value: 'value' };
    userTypeDDL: Array<any> = [
        { label: "Tender Process", value: "ZPV" }
    ];
    userDDL: Array<DropDownList> = [];
    lstAllPrincipal: Array<PrincipalCheckedModel> = [];
    lstAllMenu: Array<MenuCheckedModel> = [];
    lstAllMenuTreeView: Array<MenuCheckedTreeViewModel> = [];
    lstAllMenuTreeViewForSave: Array<MenuCheckedTreeViewModel> = [];

    constructor(private http: HttpService, private helper: HelperService) {

    }

    ngOnInit() {
    }
    
    @ViewChild('treeview')
    public tree: TreeViewComponent;        
    public menus: MenuCheckedTreeViewModel[] = [];
    
    // set the CheckBox to the TreeView
    public showCheckBox: boolean = true;
    //set the checknodes to the TreeView    
    public checkedNodes: string[] = []; 
    public nodeChecked(args): void {        

    }
    

    getUserDDL(type:string) {
        this.http.get('api/PrincipalUser/GetUserByTypeDDL?userType=' + type, res => {
            this.userDDL = res;
        }, null);
    }    

    loadTreeViewMenuChecked() {
        debugger
        if (this.userSelected > 0) {
            this.http.get('api/PrincipalUser/GetMenuCheckedByUserTreeView?userID=' + this.userSelected, res => {
                this.lstAllMenuTreeView = res;
                this.lstAllMenuTreeViewForSave = this.lstAllMenuTreeView;
                this.loadTreeViewMenuChecked2();
            }, null);
        }
        else {
            this.loadTreeViewMenuChecked2();
        }            
    }

    loadTreeViewMenuChecked2(){
        this.lstAllMenuTreeView.sort();
        let checkedNodesLocal: string[] = [];
        for (var a of this.lstAllMenuTreeView) {
            for (var b of this.lstAllMenuTreeView) {
                if (a.MenuID == b.Parent) {
                    a.hasChildren = true;
                    break;
                }
                else {
                    a.hasChildren = false;
                }
            }
        }

        for (var a of this.lstAllMenuTreeView) {
            if (a.Parent > 0) {
                if (a.hasChildren) {
                    a.expanded = true;
                }
                else {
                    a.expanded = false;
                }
            }
            else {
                a.Parent = null;
                if (a.hasChildren) {
                    a.expanded = true;
                }
                else {
                    a.expanded = false;
                }
            }
            if (a.Checked) {
                //this.checkedNodes.push(String(a.MenuID));
                checkedNodesLocal.push(String(a.MenuID));
            }
        }
        let field: Object = { dataSource: this.lstAllMenuTreeView, id: 'MenuID', parentID: 'Parent', text: 'MenuDescription', hasChildren: 'hasChildren' };

        this.tree.fields = field;

        this.tree.checkedNodes = checkedNodesLocal;
        this.tree.refresh();
        this.lstAllMenuTreeView = [];
    }

    onChangeUser(e) {
        debugger
        this.userSelected = e.value;
        //this.loadPrincipalChecked();
        //this.loadMenuChecked();
        this.loadTreeViewMenuChecked();
    }
    onChangeUserType(e) {
        this.userType = e.value;
        this.getUserDDL(this.userType)
    }
    onCheckPrincipal(item: PrincipalCheckedModel) {
        item.Checked = !item.Checked;
    }

    onCheckMenu(item: MenuCheckedModel) {
        item.Checked = !item.Checked;
    }


    saveStaffBaseMenuTreeView() {
        debugger
        //lstAllMenu: Array < MenuCheckedModel > =[];
        let lstAllMenuTree: Array < MenuCheckedModel > =[];
        for (var x of this.tree.checkedNodes) {
            var y = +x;
            for (var b of this.lstAllMenuTreeViewForSave) {
                if (y == b.MenuID) {
                    lstAllMenuTree.push(new MenuCheckedModel(b.MenuID, b.Checked, b.MenuDescription));
                }
            }
        }

        //var lstChecked = this.lstAllMenu.filter(x => x.Checked == true);
        var lstChecked = lstAllMenuTree;
        let dataSave = {
            UserID: this.userSelected,
            UserType: this.userType,
            lstMenu: lstChecked
        };

        this.http.save('api/PrincipalUser/SaveUserRoleOnMenu', dataSave, res => {
            //this.loadPrincipalChecked();
            this.loadTreeViewMenuChecked();
        }, null);
    }

    saveStaffBaseMenu() {
        var lstChecked = this.lstAllMenu.filter(x => x.Checked == true);
        let dataSave = {
            UserID: this.userSelected,
            UserType: this.userType,
            lstMenu: lstChecked
        };

        this.http.save('api/PrincipalUser/SaveUserRoleOnMenu', dataSave, res => {
            //this.loadPrincipalChecked();
        }, null);
    }
    
}
